import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePanelComponent } from './image-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ImagePanelComponent],
  exports: [ImagePanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class ImagePanelModule { }
